<script setup>
defineProps({ blok: Object })
</script>

<template>
  <div class="overflow-hidden pb-mobile pt-mobile-navbar lg:pb-desktop lg:pt-desktop-navbar">
    <div>
      <CarouselHeroComponent :blok="blok" :slide-item="blok.item" :card-item="blok.card" :card-title="blok.title" :card-subtitle="blok.subtitle" />
    </div>
  </div>
</template>
